import { Tabs, TabsProps } from "antd";
import ContaViagemTable from "./ContaViagemTable";
import ContaViagemConsultaScreen from "./ContaViagemConsultaScreen";
import TelaPermissao from "@/Components/Base/Permissao/TelaPermissao";
import SaldoPeriodoConsultaScreen from "@/Components/Populados/Relatorio/Financeiro/Conta/MovimentacaoSaldoPeriodo/SaldoPeriodoConsultaScreen";
import { EnumTipoConta } from "@/Models/Financeiro/Conta";

export interface IContaViagemTabsProps extends TabsProps {

}
export default function ContaViagemTabs ({
    ...rest
}:IContaViagemTabsProps) {
    return <Tabs 
        {...rest}
        destroyInactiveTabPane={true}
        items={[
            {
                key : "consulta",
                label : "Contas",
                children : <TelaPermissao tipo="any" permissoes={["DomainViagemFinanceiroContaViagemInserir", "DomainViagemFinanceiroContaViagemListar"]}>
                    <ContaViagemConsultaScreen />
                </TelaPermissao>
            },
            {
                key : "extrato",
                label : "Extrato",
                children : <TelaPermissao permissoes={["DomainRelatorioFinanceitoContaMovimentacaoSaldoPeriodoListarTodos"]}>
                    <SaldoPeriodoConsultaScreen 
                        cabecalhoSaldoVisivel={false}
                        intervaloObrigatorio={false}
                        initialValues={{
                            intervalo : []
                        }}
                        tableProps={{
                            hideColumns : {
                                enabled: false,
                                defaultHiddenKeys : ["centro-custo"]
                            },
                            pagination : false,
                            csv : {
                                enabled : true,
                                filename : "Extrato_ADV.csv",
                                concat : (records) => [
                                    {
                                        header : "Centro de custo",
                                        data : records.map(m => m?.centroCusto?.descricao ?? "-")
                                    }
                                ]
                            }
                        }}
                        codContaTipo={EnumTipoConta.ADIANTAMENTO_VIAGEM} 
                    />
                </TelaPermissao>
            }     
        ]}
    />
}